import React from 'react';
import { ArrowRight } from 'lucide-react';
import theme from '../../constants/theme';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Abstract Wavy Background */}
      <svg
        className="absolute inset-0 w-full h-full object-cover pointer-events-none opacity-40"
        viewBox="0 0 1440 800"
        preserveAspectRatio="xMidYMid slice"
      >
        <path className="wave-stroke" d="M-100,400 C150,500 350,200 600,400 C850,600 1150,300 1500,400" />
        <path className="wave-stroke" d="M-100,420 C150,520 350,220 600,420 C850,620 1150,320 1500,420" />
        <path className="wave-stroke" d="M-100,440 C150,540 350,240 600,440 C850,640 1150,340 1500,440" />
        <path className="wave-stroke" d="M-100,460 C150,560 350,260 600,460 C850,660 1150,360 1500,460" />
        <path className="wave-stroke" d="M-100,480 C150,580 350,280 600,480 C850,680 1150,380 1500,480" />
        <path className="wave-stroke" d="M-100,500 C150,600 350,300 600,500 C850,700 1150,400 1500,500" />
      </svg>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 w-full">
        <div className="max-w-4xl">
          <h1
            className="font-retropix text-5xl md:text-7xl lg:text-8xl leading-tight mb-6"
            style={{ color: theme.primary }}
          >
            Innovate.<br />
            Elevate.<br />
            Automate.
          </h1>
          <p className="text-lg md:text-xl mb-10 max-w-2xl leading-relaxed">
            We handle the full AI stack. From concept to edge deployment, we build intelligent systems that solve real-world problems. Don't just talk about AI—deploy it.
          </p>
          <div className="flex flex-wrap gap-4">
            <a
              href="#contact"
              className="px-8 py-4 font-bold uppercase tracking-wider flex items-center gap-2 transition-transform hover:-translate-y-1"
              style={{ backgroundColor: theme.primary, color: theme.bg }}
            >
              Start a Project <ArrowRight size={20} />
            </a>
            <a
              href="#portfolio"
              className="px-8 py-4 font-bold uppercase tracking-wider border-2 flex items-center gap-2 transition-transform hover:-translate-y-1"
              style={{ borderColor: 'rgba(26, 26, 26, 0.2)' }}
            >
              View Case Studies
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
